<template>
  <div class="flex flex-row pr-12 mb-8 space-x-4">
    <div class="text-br-green grow-0 shrink-0 w-6 h-6"><slot name="default" /></div>
    <div class="flex flex-col justify-start grow">
      <div class="fluid-xxs uppercase tracking-wide leading-tight font-medium text-gray-500">
        {{ label }}
      </div>
      <div v-if="value" class="fluid-xxs uppercase tracking-wide leading-tight font-medium">{{ value }}</div>
      <div v-else class="fluid-xxs uppercase tracking-wide leading-tight font-medium">
        <slot name="value" />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * shows label and value, if value not set, defaults to slot named value
 */
export default defineNuxtComponent({
  components: {},
  props: {
    label: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
  },
});
</script>
